export function getUser(): { user_id: string; email: string } | undefined {
  const token = localStorage.getItem('access_token')
  const user = localStorage.getItem('mbue_cache_user_data')

  if (token && token !== 'null' && user) {
    const userData = JSON.parse(user) as { data: { id: number }; email: string }

    return {
      user_id: userData.data.id.toString(),
      email: userData.email
    }
  }
  return undefined
}
